// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resource-selector {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 16px;
  background-color: transparent;
}

.resource-selector-header {
  text-align: center;
  margin-bottom: 24px;
}

.resource-selector-header h3 {
  font-size: 1.5rem;
  color: antiquewhite;
  margin-bottom: 8px;
  font-weight: 500;
}

.resource-selector-subtitle {
  color: antiquewhite;
  font-size: 0.95rem;
  line-height: 1.5;
}

.resource-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  padding: 8px;
}

.resource-item {
  position: relative;
  background-color: var(--background-color, #ffffff);
  border: 1px solid var(--border-color, #e9ecef);
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  overflow: hidden;
}

.resource-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 0;
  background-color: var(--primary-color, #007bff);
  transition: height 0.2s ease;
}

.resource-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border-color: var(--border-color, #e9ecef);
}

.resource-item:hover::before {
  height: 100%;
}

.resource-item.selected {
  background-color: var(--background-color, #ffffff);
  border-color: var(--primary-color, #007bff);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.1);
}

.resource-item.selected::before {
  height: 100%;
}

.resource-item-header {
  margin-bottom: 8px;
  position: relative;
}

.resource-item-header h4 {
  color: var(--primary-color, #007bff);
  font-size: 1rem;
  margin: 0;
  font-weight: 500;
  transition: color 0.2s ease;
  padding-left: 8px;
}

.resource-item-content h5 {
  color: var(--primary-text-color, #333);
  font-size: 0.9rem;
  margin: 0 0 8px 0;
  font-weight: 500;
  padding-left: 8px;
  line-height: 1.4;
}

.resource-item-content p {
  color: var(--secondary-text-color, #666);
  font-size: 0.85rem;
  margin: 0;
  line-height: 1.5;
  padding-left: 8px;
}

/* Add subtle hover state */
.resource-item:hover .resource-item-header h4 {
  color: var(--primary-color-dark, #0056b3);
}

/* Add animation for selection */
@keyframes selectPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(0, 123, 255, 0.2);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(0, 123, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(0, 123, 255, 0);
  }
}

.resource-item.selected {
  animation: selectPulse 1s;
}

/* Active Resource Display Styles */
.active-resource-display {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #f0f9f0;
  border: 1px solid #ccc;
  border-radius: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
  max-width: 100%;
}

.active-resource-display:hover {
  background-color: #e0f0e0;
}

.active-resource-info {
  flex: 1 1;
}

.active-resource-name {
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--primary-color, #007bff);
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.active-resource-title {
  font-size: 0.8rem;
  color: var(--secondary-text-color, #666);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.active-resource-arrow {
  margin-left: 10px;
  font-size: 12px;
  color: #555;
  transition: transform 0.3s;
}

.active-resource-arrow.open {
  transform: rotate(180deg);
}

/* Resource Dropdown (now Drop-up) Styles */
.resource-dropdown {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 100%;
  margin-bottom: 8px;
  max-height: 0;
  overflow-y: auto;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  opacity: 0;
  visibility: hidden;
  transition: max-height 0.3s, opacity 0.3s, visibility 0.3s;
  z-index: 999;
  width: 100%;
}

.resource-dropdown.open {
  max-height: 300px;
  opacity: 1;
  visibility: visible;
  border: 1px solid #ddd;
}

.resource-dropdown-item {
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: background-color 0.2s;
}

.resource-dropdown-item:first-child {
  border-radius: 12px 12px 0 0;
}

.resource-dropdown-item:last-child {
  border-bottom: none;
  border-radius: 0 0 12px 12px;
}

.resource-dropdown-item:hover {
  background-color: #f5f5f5;
}

.resource-dropdown-item.selected {
  background-color: #e0f0e0;
}

.resource-dropdown-name {
  font-weight: bold;
  color: #166534;
  margin-bottom: 4px;
}

.resource-dropdown-title {
  font-size: 14px;
  color: #444;
}

/* Scrollbar Styles */
.resource-dropdown::-webkit-scrollbar {
  width: 6px;
}

.resource-dropdown::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.resource-dropdown::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}

.resource-dropdown::-webkit-scrollbar-thumb:hover {
  background: #999;
}

/* Container positioning */
.active-resource-container {
  position: relative;
  width: 100%;
  z-index: 100;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  max-width: 600px;
  margin: 0 auto;
}

/* Ensure the dropdown doesn't get cut off at the top */
.chatscreen-input-container {
  margin-top: 8px;
  position: relative;
  z-index: 1;
}

/* Add these new styles for the search functionality */
.resource-search-container {
  padding: 8px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 2;
  border-radius: 12px 12px 0 0;
}

.resource-search-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
}

.resource-search-input:focus {
  border-color: #166534;
  box-shadow: 0 0 0 2px rgba(22, 101, 52, 0.2);
}

.resource-dropdown-no-results {
  padding: 12px;
  text-align: center;
  color: #666;
  font-style: italic;
} `, "",{"version":3,"sources":["webpack://./src/chat/ResourceSelector/ResourceSelector.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,8CAA8C;EAC9C,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,SAAS;EACT,+CAA+C;EAC/C,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kDAAkD;EAClD,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,yCAAyC;AAC3C;;AAEA,gCAAgC;AAChC;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;EACV,kBAAkB;EAClB,0DAA0D;EAC1D,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,4DAA4D;EAC5D,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA,sDAAsD;AACtD;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,gBAAgB;EAChB,MAAM;EACN,uBAAuB;EACvB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".resource-selector {\n  width: 100%;\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 16px;\n  background-color: transparent;\n}\n\n.resource-selector-header {\n  text-align: center;\n  margin-bottom: 24px;\n}\n\n.resource-selector-header h3 {\n  font-size: 1.5rem;\n  color: antiquewhite;\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.resource-selector-subtitle {\n  color: antiquewhite;\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n.resource-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 16px;\n  padding: 8px;\n}\n\n.resource-item {\n  position: relative;\n  background-color: var(--background-color, #ffffff);\n  border: 1px solid var(--border-color, #e9ecef);\n  border-radius: 12px;\n  padding: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  overflow: hidden;\n}\n\n.resource-item::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 3px;\n  height: 0;\n  background-color: var(--primary-color, #007bff);\n  transition: height 0.2s ease;\n}\n\n.resource-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  border-color: var(--border-color, #e9ecef);\n}\n\n.resource-item:hover::before {\n  height: 100%;\n}\n\n.resource-item.selected {\n  background-color: var(--background-color, #ffffff);\n  border-color: var(--primary-color, #007bff);\n  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.1);\n}\n\n.resource-item.selected::before {\n  height: 100%;\n}\n\n.resource-item-header {\n  margin-bottom: 8px;\n  position: relative;\n}\n\n.resource-item-header h4 {\n  color: var(--primary-color, #007bff);\n  font-size: 1rem;\n  margin: 0;\n  font-weight: 500;\n  transition: color 0.2s ease;\n  padding-left: 8px;\n}\n\n.resource-item-content h5 {\n  color: var(--primary-text-color, #333);\n  font-size: 0.9rem;\n  margin: 0 0 8px 0;\n  font-weight: 500;\n  padding-left: 8px;\n  line-height: 1.4;\n}\n\n.resource-item-content p {\n  color: var(--secondary-text-color, #666);\n  font-size: 0.85rem;\n  margin: 0;\n  line-height: 1.5;\n  padding-left: 8px;\n}\n\n/* Add subtle hover state */\n.resource-item:hover .resource-item-header h4 {\n  color: var(--primary-color-dark, #0056b3);\n}\n\n/* Add animation for selection */\n@keyframes selectPulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 123, 255, 0.2);\n  }\n  70% {\n    box-shadow: 0 0 0 6px rgba(0, 123, 255, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(0, 123, 255, 0);\n  }\n}\n\n.resource-item.selected {\n  animation: selectPulse 1s;\n}\n\n/* Active Resource Display Styles */\n.active-resource-display {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  background-color: #f0f9f0;\n  border: 1px solid #ccc;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  max-width: 100%;\n}\n\n.active-resource-display:hover {\n  background-color: #e0f0e0;\n}\n\n.active-resource-info {\n  flex: 1;\n}\n\n.active-resource-name {\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: var(--primary-color, #007bff);\n  margin-bottom: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.active-resource-title {\n  font-size: 0.8rem;\n  color: var(--secondary-text-color, #666);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.active-resource-arrow {\n  margin-left: 10px;\n  font-size: 12px;\n  color: #555;\n  transition: transform 0.3s;\n}\n\n.active-resource-arrow.open {\n  transform: rotate(180deg);\n}\n\n/* Resource Dropdown (now Drop-up) Styles */\n.resource-dropdown {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 100%;\n  margin-bottom: 8px;\n  max-height: 0;\n  overflow-y: auto;\n  background-color: white;\n  border-radius: 12px;\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n  opacity: 0;\n  visibility: hidden;\n  transition: max-height 0.3s, opacity 0.3s, visibility 0.3s;\n  z-index: 999;\n  width: 100%;\n}\n\n.resource-dropdown.open {\n  max-height: 300px;\n  opacity: 1;\n  visibility: visible;\n  border: 1px solid #ddd;\n}\n\n.resource-dropdown-item {\n  padding: 12px 16px;\n  border-bottom: 1px solid #eee;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.resource-dropdown-item:first-child {\n  border-radius: 12px 12px 0 0;\n}\n\n.resource-dropdown-item:last-child {\n  border-bottom: none;\n  border-radius: 0 0 12px 12px;\n}\n\n.resource-dropdown-item:hover {\n  background-color: #f5f5f5;\n}\n\n.resource-dropdown-item.selected {\n  background-color: #e0f0e0;\n}\n\n.resource-dropdown-name {\n  font-weight: bold;\n  color: #166534;\n  margin-bottom: 4px;\n}\n\n.resource-dropdown-title {\n  font-size: 14px;\n  color: #444;\n}\n\n/* Scrollbar Styles */\n.resource-dropdown::-webkit-scrollbar {\n  width: 6px;\n}\n\n.resource-dropdown::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n.resource-dropdown::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 3px;\n}\n\n.resource-dropdown::-webkit-scrollbar-thumb:hover {\n  background: #999;\n}\n\n/* Container positioning */\n.active-resource-container {\n  position: relative;\n  width: 100%;\n  z-index: 100;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n/* Ensure the dropdown doesn't get cut off at the top */\n.chatscreen-input-container {\n  margin-top: 8px;\n  position: relative;\n  z-index: 1;\n}\n\n/* Add these new styles for the search functionality */\n.resource-search-container {\n  padding: 8px 12px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  position: sticky;\n  top: 0;\n  background-color: white;\n  z-index: 2;\n  border-radius: 12px 12px 0 0;\n}\n\n.resource-search-input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  font-size: 14px;\n  outline: none;\n}\n\n.resource-search-input:focus {\n  border-color: #166534;\n  box-shadow: 0 0 0 2px rgba(22, 101, 52, 0.2);\n}\n\n.resource-dropdown-no-results {\n  padding: 12px;\n  text-align: center;\n  color: #666;\n  font-style: italic;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
